
import { defineComponent, ref } from "vue";
import BillingInfoChange from "./BillingInfoChange.vue";
import CollapsableContainer from "./CollapsableContainer.vue";
import PlansFeatures from "./PlansFeatures.vue";
import CouponForm from "./CouponForm.vue";
import PlanCost from "./PlanCost.vue";
import StatusBlock from "./StatusBlock.vue";
import LoadingModal from "./LoadingModal.vue";
import { States, submitHandler } from "./submit_handler";
import { useUserStore } from "@/store/user";
import { useConfigStore } from "@/store/config";

export default defineComponent({
  components: {
    BillingInfoChange,
    PlansFeatures,
    CollapsableContainer,
    CouponForm,
    PlanCost,
    LoadingModal,
    StatusBlock,
  },
  props: {
    show: {
      type: Boolean,
      required: true,
    },
  },
  setup() {
    const user = useUserStore();
    const plansMap = useConfigStore().plansMap;
    let states: States = {
      recaptcha: null,
      loadingShow: ref(false),
      errorMessage: ref(""),
      captchaEnabled: false,
    };

    interface CouponDiscount {
      code: string | null;
      discount: null | {
        type: "percent" | "fixed";
        value: number;
      }
    }

    const coupon = ref<CouponDiscount>({
      code: null,
      discount: null
    });

    let planSelected = ref({
      code: "otcpro"
    });
    let billingInfoEditEnabled = ref(user.billingInfo ? false : true);

    let formDisabled = ref(billingInfoEditEnabled);

    function disableBillingInfoEdit() {
      billingInfoEditEnabled.value = false;
    }

    function activateSubscription() {
      submitHandler(
        user.activateSubscription({
          planCode: planSelected.value.code,
          couponCode: coupon.value.code ? coupon.value.code : undefined
        }),
        states
      );
    }

    function couponApplied(couponData: CouponDiscount) {
      coupon.value = couponData;
    }

    function formatPrice(planCode: string) {
      let price = plansMap.get(planCode)?.unitAmount;
      return price ? `${(price / 100).toFixed(2)}` : null;
    }

    return {
      errorMessage: states.errorMessage,
      loadingShow: states.loadingShow,
      planSelected,
      formDisabled,
      billingInfoEditEnabled,
      disableBillingInfoEdit,
      coupon,
      couponApplied,
      activateSubscription,
      formatPrice
    };
  },
});
